
import React, { useState, useEffect } from 'react';
import { useBuilder, useBuilderDispatch, BuilderProvider } from '../../components/index';
import { Row, Col, Container, Button, InputGroup, Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { getOpReports } from '../../components/deityRequests';
import ItemPowerReport from './ItemPowerReport';
import ItemPowerMetrics from './ItemPowerReportMetrics';
import ItemPowerEditor from './ItemPowerEditor';

const BuilderItemPowerReports = ({ match, extraParams }) => {
    let parms = useParams();
    return (<BuilderProvider><BuilderItemPowerReportsInternal search={parms} /></BuilderProvider>);
}

const BuilderItemPowerReportsInternal = ({ search }) => {

    const [owner, setOwner] = useState('');
    const [location, setLocation] = useState('');
    const [itemName, setItemName] = useState('');
    const [filter, setFilter] = useState('');
    const [opReports, setOpReports] = useState([]);
    const [sortMode, setSortMode] = useState(0);
    const [showEditor, setShowEditor] = useState(false);
    const [selectedItemHeader, setSelectedItemHeader] = useState();

    useEffect(() => {
        getAuditReviews();
    }, []);

    useEffect(() => {
        console.log('sorting ', sortMode);
        switch (sortMode) {
            case 0:
                setOpReports([...opReports.sort((a, b) => a.item_name.localeCompare(b.item_name))]);
                break;
            case 1:
                setOpReports([...opReports.sort((a, b) => a.item_owner.localeCompare(b.item_owner))]);
                break;
            case 2:
                setOpReports([...opReports.sort((a, b) => a.item_location.localeCompare(b.item_location))]);
                break;
            case 3:
                setOpReports([...opReports.sort((a, b) => b.item_power - a.item_power)]);
                break;
        }
    }, [sortMode]);

    const getAuditReviews = async () => {
        let data = await getOpReports(owner, location, itemName);
        if (data.result) {
            switch (sortMode) {
                case 0:
                    data.reports.sort((a, b) => b.item_name.localeCompare(a.item_name));
                    break;
                case 1:
                    data.reports.sort((a, b) => b.item_owner.localeCompare(a.item_owner));
                    break;
                case 2:
                    data.reports.sort((a, b) => b.item_location.localeCompare(a.item_location));
                    break;
                case 3:
                    data.reports.sort((a, b) => b.item_power - a.item_power);
                    break;
            }
            setOpReports(data.reports);
        } else {
            setOpReports([]);
        }
    }

    const filterMatch = (review) => {
        if (filter === '') {
            //console.log(`[filterMatch] skipped`, review);
            return true;
        }

        let result = (review.item_name.toLowerCase().indexOf(filter.toLowerCase()) > -1);
        //||(review.location.toLowerCase().indexOf(filter.toLowerCase()) > -1);

        //console.log(`[filterMatch] ${result ? 'success' : 'failure'}`, review);
        return result;

    }

    const showItemEditorModal = (itemHeader) => {
        setSelectedItemHeader(itemHeader);
        setShowEditor(true);
    }

    const hideItemEditorModal = () => {
        setSelectedItemHeader();
        setShowEditor(false);
    }


    return (
        <div className="container container-wide" id="divMainContent">
            <ItemPowerEditor show={showEditor} handleClose={hideItemEditorModal} itemHeader={selectedItemHeader}/>
            <h1>Item Power Report</h1>
            <br />

            <Row>

                <Col xs={2} >
                    <ItemPowerMetrics />
                </Col>
                <Col xs={10}>
                    <Row className={"flex-nowrap"}>

                        <Col xs={1}>
                            <Button onClick={() => getAuditReviews()}>Refresh</Button>
                        </Col>
                        <Col xs={3}>
                            <InputGroup className="mb-3">
                                <p>Owner</p>
                                <input type="text" className="form-control" onChange={(e) => setOwner(e.currentTarget.value)} value={owner} />
                            </InputGroup>
                        </Col>
                        <Col xs={3}>
                            <InputGroup className="mb-3">
                                <p>Location</p>
                                <input type="text" className="form-control" onChange={(e) => setLocation(e.currentTarget.value)} value={location} />
                            </InputGroup>
                        </Col>
                        <Col xs={3}>
                            <InputGroup className="mb-3">
                                <p>Item Name</p>
                                <input type="text" className="form-control" onChange={(e) => setItemName(e.currentTarget.value)} value={itemName} />
                            </InputGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={1}>
                            <p>Filter</p>
                        </Col>
                        <Col>
                            <input type="text" className="form-control" onChange={(e) => setFilter(e.currentTarget.value)} />
                        </Col>

                    </Row>

                    <Row>
                        <Row>
                            <Col xl={4}>
                                <p onClick={() => setSortMode(0)}>Item Name</p>
                            </Col>
                            <Col>
                                <p onClick={() => setSortMode(1)}>Owner</p>
                            </Col>
                            <Col>
                                <p onClick={() => setSortMode(2)}>Item Location</p>
                            </Col>
                            <Col>
                                <p onClick={() => setSortMode(3)}>Item Power</p>
                            </Col>
                        </Row>
                        {opReports.filter(report => filterMatch(report)).map((report, index) => {
                            return (<>
                                <ItemPowerReport key={index} report={report} selectItem={showItemEditorModal}/>
                            </>)
                        })}

                    </Row>
                </Col>
            </Row>



        </div>
    );
}



export default BuilderItemPowerReports;